// extracted by css-extract-rspack-plugin
var _1 = "buttonWrapper__r1Nuw";
var _2 = "pageDescription__jGceP";
export { _1 as "buttonWrapper", _2 as "pageDescription" }
export default { "buttonWrapper": _1, "pageDescription": _2 }
